import { NotRequired as PoaNotRequired } from './not-required';

export default PoaNotRequired;
